import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatment-courses/treatment-course-types/style'

/** API */

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import TableRowExport from 'component/Pdf/TableRowExport'
import ButtonExport from 'component/Button/ButtonExport'
import TemplateFormsTypeApi from 'api/setting/doctor-note/template-form-type.api'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const initStateErrorMessage = {
    TEMPLATE_FORM_TYPE_NAME: ``,
    IS_DUPLICATE_TEMPLATE_FORM_TYPE_NAME: ``,
    TEMPLATE_FORM_TYPE_NAME_STRING_BASE: ``,
    TEMPLATE_FORM_TYPE_NAME_STRING_EMPTY: ``,
    TEMPLATE_FORM_TYPE_NAME_MAXIMUM_LENGTH: ``,
    TEMPLATE_FORM_TYPE_NAME_ANY_REQUIRED: ``,

    TEMPLATE_FORM_TYPE_NAME_EN: ``,
    IS_DUPLICATE_TEMPLATE_FORM_TYPE_NAME_EN: ``,
    TEMPLATE_FORM_TYPE_NAME_EN_STRING_BASE: ``,
    TEMPLATE_FORM_TYPE_NAME_EN_STRING_EMPTY: ``,
    TEMPLATE_FORM_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
    TEMPLATE_FORM_TYPE_NAME_EN_ANY_REQUIRED: ``
}

export default function TemplateFormType() {
    const classes = useStyles()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [treatmentCourseTypes, setTreatmentCourseTypes] = useState([])
    const [exportData, setExportData] = useState([])

    const [templateFormId, setTemplateFormId] = useState(Number)
    const [templateFormName, setTemplateFormName] = useState('')
    const [templateFormNameEn, setTemplateFormNameEn] = useState('')
    const [templateFormStatus, setTemplateFormStatus] = useState('')

    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

    /** PAGINATION  */
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createdAt')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('ALL')

    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [nameEn, setNameEn] = useState('')
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const loadData = useCallback(async () => {
        let condition: any = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (search) condition = { ...condition, search: search }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

        const res = await TemplateFormsTypeApi.findAll(condition)
        if (res.status === 200) {
            setRowCount(res.headers['x-total'])
            setTreatmentCourseTypes(res.data)
        }
    }, [page, pageLimit, search, sortBy, sortType, status])

    useEffect(() => {
        loadData()
    }, [loadData])

    const loadDataForExport = useCallback(async () => {
        let condition: any = {}
        condition.export = 1
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (search) condition = { ...condition, search: search }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

        const res = await TemplateFormsTypeApi.findAll(condition)
        if (res.status === 200) {
            setExportData(res.data)
        }
    }, [page, pageLimit, search, sortBy, sortType, status])

    useEffect(() => {
        loadDataForExport()
    }, [loadDataForExport])

    const submit = () => {
        if (!templateFormName) return setErrorMessage({ ...errorMessage, ...{ TEMPLATE_FORM_TYPE_NAME: t('TEMPLATE_FORM_TYPE.MESSAGE.TEMPLATE_FORM_TYPE_NAME') } })

        dispatch(submitModal())
        TemplateFormsTypeApi.create({ typeName: templateFormName, typeNameEn: templateFormNameEn })
            .then((res: any) => {
                if (res.status !== undefined && res.status === 201) {
                    notiSuccess(t('TEMPLATE_FORM_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
                    resetForm()
                    loadData()
                    dispatch(resetModal())
                } else {
                    const err = res.response.data
                    setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_FORM_TYPE.MESSAGE.${err.message}`) } })
                    dispatch(unSubmitModal())
                }
            })
            .catch((e) => {
                const err = e.response.data
                setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_FORM_TYPE.MESSAGE.${err.message}`) } })
                dispatch(unSubmitModal())
            })
    }

    const submitEdit = () => {
        if (!templateFormName) return setErrorMessage({ ...errorMessage, ...{ TEMPLATE_FORM_TYPE_NAME: t(`TEMPLATE_FORM_TYPE.MESSAGE.TEMPLATE_FORM_TYPE_NAME`) } })

        dispatch(submitModal())
        TemplateFormsTypeApi.update(templateFormId, {
            typeName: templateFormName,
            typeNameEn: templateFormNameEn,
            status: templateFormStatus
        })
            .then((res: any) => {
                if (res.status !== undefined && res.status === 200) {
                    notiSuccess(t(`TEMPLATE_FORM_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
                    resetForm()
                    loadData()
                    dispatch(resetModal())
                } else {
                    const err = res.response.data
                    setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_FORM_TYPE.MESSAGE.${err.message}`) } })
                    dispatch(unSubmitModal())
                }
            })
            .catch((e) => {
                const err = e.response.data
                setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_FORM_TYPE.MESSAGE.${err.message}`) } })
                dispatch(unSubmitModal())
            })
    }

    const clearErrorMessage = () => {
        setErrorMessage(initStateErrorMessage)
    }

    const resetForm = () => {
        setTemplateFormId(0)
        setTemplateFormName('')
        setTemplateFormNameEn('')
        setTemplateFormStatus('')
        clearErrorMessage()
    }

    const onActive = () => {
        if (id) {
            TemplateFormsTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('TEMPLATE_FORM_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('TEMPLATE_FORM_TYPE.MESSAGE.ERROR'))
                }
            })
        }
    }
    const onDelete = () => {
        if (id) {
            TemplateFormsTypeApi.remove(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('TEMPLATE_FORM_TYPE.MESSAGE.SUCCESS.DELETE'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('TEMPLATE_FORM_TYPE.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onEdit = (data: any) => {
        const { templateFormTypeId, typeName, typeNameEn, status: dcTypeStatus } = data
        setTemplateFormId(templateFormTypeId)
        setTemplateFormName(typeName)
        setTemplateFormNameEn(typeNameEn)
        setTemplateFormStatus(dcTypeStatus)
        dispatch(showModal())
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }
    const handleChangeStatus = (statusVal: string) => {
        setStatus(statusVal)
    }
    const headCells = [
        { id: 'no', disablePadding: false, label: '#' },
        { id: 'treatmentCourseTypeName', disablePadding: false, label: t('TEMPLATE_FORM_TYPE.TABLE.CELL.TEMPLATE_FORM_TYPE_NAME') },
        { id: 'templateFormName', disablePadding: false, label: t('TEMPLATE_FORM_TYPE.TABLE.CELL.TEMPLATE_FORM_TYPE_NAME_EN') },
        { id: 'status', disablePadding: false, label: t('TEMPLATE_FORM_TYPE.TABLE.CELL.STATUS') },
        { id: 'updatedBy', disablePadding: false, label: t('TEMPLATE_FORM_TYPE.TABLE.CELL.UPDATED_BY') },
        { id: 'action', disablePadding: false, label: 'Action' }
    ]

    const renderData = (objData: any, no: number, valueExportData: boolean) => {
        const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
        const { templateFormTypeId, typeName, typeNameEn, updatedBy, updatedAt, status: dcTypeStatus } = objData
        const statusBtnActive = dcTypeStatus === 'ACTIVE' ? true : false
        const statusBtnInActive = dcTypeStatus === 'INACTIVE' ? true : false
        const objRenderData = {
            key: templateFormTypeId,
            id: templateFormTypeId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: typeName || '-' },
                { option: 'TEXT', align: 'left', label: typeNameEn || '-' },
                { option: 'STATUS', align: 'center', label: dcTypeStatus },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
                        { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
                    ]
                }
            ]
        }
        return (
            <>
                {valueExportData === true && <TableRowExport {...objRenderData} /> ||
                    <TableRowCommon
                        {...objRenderData}
                        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
                        onedit={() => onEdit(objRenderData.obj)}
                        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
                    />
                }
            </>
        )
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.typeName)
        setNameEn(obj.typeNameEn)
    }

    const filter = [
        { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
        { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
    ]

    return (
        <div className={classes.root}>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`TEMPLATE_FORM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`TEMPLATE_FORM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentCourseTypeName: name, treatmentCourseTypeNameEn: nameEn && `(${nameEn})`, status: t(`TEMPLATE_FORM_TYPE.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <Card className="border-0 h-100">
                <HeaderCard text={t('TEMPLATE_FORM_TYPE.TITLE')} />
                <Card.Body>
                    <Card.Title className={'mb-0 pl-xl-3'}>
                        <Row className="align-items-center">
                            <Col lg={7}>
                                <Row className="flax-row">
                                    <Col sm={12} md={6} xl={4} className="pt-2">
                                        <InputTextSearch
                                            keyInput={'search'}
                                            label={t('TEMPLATE_FORM_TYPE.SEARCH')}
                                            value={search}
                                            onchange={(event) => {
                                                setSearch(event.target.value)
                                                setPage(1)
                                            }}
                                            onClear={(event) => {
                                                setSearch('')
                                                setPage(1)
                                            }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                                        <FilterSelect
                                            formControlClass='not-max-width'
                                            onchange={(event) => {
                                                const value = event.target.value
                                                if (value) {
                                                    handleChangeStatus(value)
                                                    setPage(1)
                                                }
                                            }}
                                            renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                                            label={t('STATUS.LABEL')}
                                            selectId="select-status"
                                            value={status}
                                            labelId="label-status"
                                            options={[
                                                <MenuItem key="1" value="ALL">
                                                    {t('STATUS.ALL')}
                                                </MenuItem>,
                                                <MenuItem key="2" value="ACTIVE">
                                                    {t('STATUS.ACTIVE')}
                                                </MenuItem>,
                                                <MenuItem key="3" value="INACTIVE">
                                                    {t('STATUS.INACTIVE')}
                                                </MenuItem>
                                            ]}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xm={12} lg={5} className="mt-2 mt-xm-auto">
                                <div className="pr-xl-2 d-flex">
                                    <div className='ml-auto'>
                                        <ButtonExport headCells={headCells} portrait={true} filter={filter} fileName={'ประเภทฟอร์มเทมเพลต'}
                                            rowsData={exportData.map((val, i) => {
                                                return renderData(val, i, true)
                                            })} />
                                    </div>
                                    <div className='pl-3'>
                                        <ButtonCustom style={{ width: '250px' }} mode="add" onClick={() => dispatch(showModal())} textButton={t('TEMPLATE_FORM_TYPE.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" btnStyle={{ height: '44px' }} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Title>

                    <div className={'mt-3 pl-xl-3 pr-xl-2'}>
                        <TableCustom
                            page={page}
                            pageLimit={pageLimit}
                            sortType={sortType}
                            sortBy={sortBy}
                            onSort={onRequestSort}
                            setPageLimit={handleChangeRowsPerPage}
                            setPage={handleChangePage}
                            rowCount={rowCount}
                            headCells={headCells}
                            rowsData={treatmentCourseTypes.map((val, i) => {
                                return renderData(val, i, false)
                            })}
                        />
                    </div>
                </Card.Body>
            </Card>

            <ModalCustom
                title={templateFormId ? t('TEMPLATE_FORM_TYPE.TITLE_UPDATE') : t('TEMPLATE_FORM_TYPE.TITLE_CREATE')}
                component={
                    <div className="pb-2">
                        {templateFormId ? (
                            <div>
                                <Form className="mx-0 mt-0 mb-3 p-0  d-inline-flex w-100">
                                    <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                                    <Form.Check
                                        type="switch"
                                        id="custom-switch"
                                        onChange={() => setTemplateFormStatus(templateFormStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                                        checked={templateFormStatus === 'ACTIVE' ? true : false}
                                        style={{ marginLeft: 'auto' }}
                                    />
                                </Form>
                            </div>
                        ) : (
                            ''
                        )}

                        <InputTextField
                            onchange={(event) => {
                                setTemplateFormName(event.target.value)
                                clearErrorMessage()
                            }}
                            value={templateFormName}
                            label={t('TEMPLATE_FORM_TYPE.INPUT.TEMPLATE_FORM_TYPE_NAME')}
                            helperText={
                                errorMessage.TEMPLATE_FORM_TYPE_NAME ||
                                errorMessage.IS_DUPLICATE_TEMPLATE_FORM_TYPE_NAME ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_STRING_BASE ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_STRING_EMPTY ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_MAXIMUM_LENGTH ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_ANY_REQUIRED
                            }
                            required={true}
                            style={{ marginBottom: '1rem' }}
                        />
                        <InputTextField
                            key="templateFormNameEn"
                            onchange={(event) => {
                                setTemplateFormNameEn(event.target.value)
                                clearErrorMessage()
                            }}
                            value={templateFormNameEn}
                            helperText={
                                errorMessage.IS_DUPLICATE_TEMPLATE_FORM_TYPE_NAME_EN ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_EN_STRING_BASE ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_EN_STRING_EMPTY ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_EN_MAXIMUM_LENGTH ||
                                errorMessage.TEMPLATE_FORM_TYPE_NAME_EN_ANY_REQUIRED
                            }
                            label={t('TEMPLATE_FORM_TYPE.INPUT.TEMPLATE_FORM_TYPE_NAME_EN')}
                            required={false}
                        />
                    </div>
                }
                onReset={resetForm}
                onSubmit={templateFormId ? submitEdit : submit}
                textBtnCancel={t('TEMPLATE_FORM_TYPE.BUTTON.CANCEL')}
                textBtnConfirm={t('TEMPLATE_FORM_TYPE.BUTTON.SAVE')}
            />
        </div>
    )
}
